module.exports = __webpack_public_path__ + "img/lamp-charge.e5f30956.svg";